import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import {
  FaHome,
  FaImages, 
  FaCalculator,
  FaSignOutAlt,
  FaUserCog, 
  FaSolarPanel,
  FaEdit,
  FaVideo,
  FaInfoCircle,
  FaCogs,
  FaLeaf,
  FaChartBar,
  FaSun,
  FaBolt,
  FaQuoteLeft,
  FaQuestionCircle,
  FaEnvelope,
  FaUser
  
     } from 'react-icons/fa';
// 1. Import CSS Module
import styles from './Admin.module.css';

const AdminLayout = () => {
  const navigate = useNavigate();
  const user = localStorage.getItem('user') || 'Admin';

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin/login');
  };

  return (
    // 2. Use "adminTheme" container class
    <div className={styles.adminTheme}>
      
      {/* Sidebar Section */}
      <aside className={styles.sidebar}>
        <div className={styles.sidebarLogo}>
          <FaSolarPanel /> Rengie Admin
        </div>

        <ul className={styles.navLinks}>
          <li>
            <NavLink 
              to="/admin/dashboard" 
              // Active class handling with Module
              className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}
            >
              <FaHome /> Dashboard
            </NavLink>
          </li>

          <li>
          <NavLink 
            to="/admin/hero-settings" 
            className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}
          >
            <FaEdit /> Edit Home Hero
          </NavLink>
        </li>


        <li>
          <NavLink 
            to="/admin/video-settings" 
            className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}
          >
            <FaVideo /> Video Section
          </NavLink>
        </li>
        <li>
        <NavLink to="/admin/about-settings" className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}>
          <FaInfoCircle /> About Section
        </NavLink>
        </li>

        <li>
          <NavLink to="/admin/services" className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}>
            <FaCogs /> Manage Services
          </NavLink>
        </li>

        <li>
          <NavLink to="/admin/benefits" className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}>
            <FaLeaf /> Benefits & Impact
          </NavLink>
        </li>

        <li>
          <NavLink 
            to="/admin/statistics" 
            className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}
          >
            <FaChartBar /> Manage Statistics
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin/pm-suryaghar" className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}>
            <FaSun /> PM Suryaghar
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin/net-metering" className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}>
            <FaBolt /> Net Metering
          </NavLink>
        </li>

        <li>
          <NavLink to="/admin/process-steps" className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}>
            <FaCogs /> How It Works
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin/testimonials" className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}>
            <FaQuoteLeft /> Testimonials
          </NavLink>
        </li>
        <li>
          <NavLink to="/admin/faq" className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}>
            <FaQuestionCircle /> FAQ Manager
          </NavLink>
        </li>
          <li>
            <NavLink 
              to="/admin/gallery" 
              className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}
            >
              <FaImages /> Manage Gallery
            </NavLink>
          </li>
          <li>
              <NavLink to="/admin/newsletter" className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}>
                <FaEnvelope /> Newsletter
              </NavLink>
            </li>
            <li>
            <NavLink to="/admin/contact-leads" className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}>
              <FaUser /> Contact Leads
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/admin/calculator-rates" 
              className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}
            >
              <FaCalculator /> Update Rates
            </NavLink>
          </li>
          <li>
            <NavLink 
              to="/admin/settings" 
              className={({ isActive }) => isActive ? `${styles.navItem} ${styles.active}` : styles.navItem}
            >
              <FaUserCog /> Settings
            </NavLink>
          </li>
        </ul>

        {/* Logout Button with combined classes */}
        <button onClick={handleLogout} className={`${styles.navItem} ${styles.logoutBtn}`}>
          <FaSignOutAlt /> Logout
        </button>
      </aside>

      {/* Main Content Section */}
      <main className={styles.mainContent}>
        <div className={styles.headerBar}>
          <h2 className={styles.pageTitle}>Overview</h2>
          <div className={styles.adminProfile}>
            <span>Hello, <strong>{user}</strong></span>
            <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: '#4ade80' }}></div>
          </div>
        </div>

        {/* Child Pages Load Here */}
        <Outlet /> 
      </main>
    </div>
  );
};

export default AdminLayout;